export default "__VITE_ASSET__PJlOvwAA__"